/**
 * Central configuration file for API endpoints
 */

import { CONFIG } from './environment';

// Use environment-aware configuration
export const API_BASE_URL = CONFIG.BACKEND_URL;

// For any API endpoint constants used across the application
// Atualizados para usar o prefixo correto /padel/
export const API_ENDPOINTS = {
  LOGIN: `${API_BASE_URL}/padel/login/`,
  REGISTER: `${API_BASE_URL}/padel/register/`,
  USER_PROFILE: `${API_BASE_URL}/padel/profile/`,
  CLUBS: `${API_BASE_URL}/padel/list/`,
  GAMES: `${API_BASE_URL}/padel/games/`,
  TOURNAMENTS: `${API_BASE_URL}/padel/tournaments/`,
  STATS: `${API_BASE_URL}/padel/get-all-counts/`,
  CREATE_USER: `${API_BASE_URL}/padel/create-or-update-user/`,
  // Add other endpoints as needed
};

// For configuring axios defaults
export const API_CONFIG = {
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  timeout: 10000,
};
